export default "__VITE_ASSET__DxtHwfyA__"